module.exports = __webpack_public_path__ + "img/sidebar-logo-text.28c6abf2.svg";